import { offerAll, offerAssociateProduct, offerById, offerCreate, offerDelete, offerPublic, offerPublicOnly, offerUpdate, productAll, productCreate, productDelete, productUpdate } from "../../routes/api/paths";
import { handleResponse, requestOptions } from "../HandlerService";

// OFFERS
export const OffersPublicService = async () => {
  const options = requestOptions('GET', {});
  return fetch(offerPublic, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const OffersPublicOnlyService = async () => {
  const options = requestOptions('GET', {});
  return fetch(offerPublicOnly, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const OffersAllService = async ({ token, search, orderBy, orderField }) => {
  const options = requestOptions('GET', {}, token);
  return fetch(`${offerAll}?orderBy=${orderBy || 'asc'}&orderField=${orderField || 'id'}${search ? `&search=${search}` : ''}`, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const OffersByIdService = async ({ token, id }) => {
  const options = requestOptions('GET', {}, token);
  return fetch(offerById(id), options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const OffersCreateService = async ({ token, data }) => {
  const options = requestOptions('POST', data, token);
  return fetch(offerCreate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const OffersUpdateService = async ({ token, data }) => {
  const options = requestOptions('PUT', data, token);
  return fetch(offerUpdate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const OffersAssociateProductsService = async ({ token, data }) => {
  const options = requestOptions('POST', { associate: data }, token);
  return fetch(offerAssociateProduct, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const OffersDeleteService = async ({ token, ids }) => {
  const options = requestOptions('DELETE', { id: ids }, token);
  return fetch(offerDelete, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

// PRODUCTS
export const ProductsAllService = async (search = '', orderBy, orderField, promo_id) => {
  const options = requestOptions('GET', {});
  return fetch(`${productAll}?orderBy=${orderBy || 'asc'}&orderField=${orderField || 'id'}${search ? `&search=${search}` : ''}${promo_id ? `&promo_id=${promo_id}` : ''}`, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const ProductCreateService = async (data) => {
  const { token, product } = data;
  const options = requestOptions('POST', product, token);
  return fetch(productCreate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const ProductUpdateService = async (data) => {
  const { token, product } = data;
  const options = requestOptions('PUT', product, token);
  return fetch(productUpdate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const ProductDeleteService = async (data) => {
  const { token, id } = data;
  const options = requestOptions('DELETE', { id: [id] }, token);
  return fetch(productDelete, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}